import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'

import moment from 'moment'
import 'moment/min/locales'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import AtributoDinamicoInstancia from '../atributoDinamico/AtributoDinamicoInstancia.js'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import { atributosDinamicosRequeridosFaltantes, castValoresDinamicos } from '../atributoDinamico/helpers.js'
import swal2 from 'sweetalert2'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import FirmaCanvas from './FirmaCanvas.js'
import DatePicker from 'react-datepicker'
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";
import LocaleFormat from "../../commons/utils/LocaleFormat.js";

class SafeFeedbackFormularioRespuesta extends Component {
  	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();

		moment.locale("es");

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				valores_dinamicos: [],
				tipo_formulario: null,
				dominio: "",
				imagenes: null,
				documentos: null,
				base: null,
				fecha_hora: null,
			},
			valores_dinamicos: [],
			mostrarBase: false,
			descripcion: "",
			errors: [],
			loading: false,
			bases: [],
		};

		this.handleChangeAtributoDinamico = this.handleChangeAtributoDinamico.bind(this);
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.getBackendTipoForms = this.getBackendTipoForms.bind(this);
		this.handleTipoFormularioChange = this.handleTipoFormularioChange.bind(this);
		this.handleDatePickerFormChange = this.handleDatePickerFormChange.bind(this);
		this.formValidation = new FormValidation({
			component: this,
			validators: {
				"formData.tipo_formulario": (value) => Validator.notEmpty(value),
				"formData.dominio": (value) => Validator.notEmpty(value),
			},
		});
  	}

	handleDatePickerFormChange(event) {
		let date = event ? event.format(): '';
		if(date === "")
			date = null;
		
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.fecha_hora = date;
		this.setState({
			formData: formDataCopy
		});
	}

	handleDatePickerFormRawChange(date) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		if(date === "")
			date = null;
		formDataCopy.fecha_hora = date;
		this.setState({
			formData: formDataCopy
		});
	}

	loadConfigBusiness() {
		this.getConfig();
		this.getConfigBusiness()
			.then(() => {
				this.setState({ configBusinessLoading: false }); // se ha cargado configBusiness
			})
			.catch(() => {
				this.setState({ configBusinessLoading: false }); // ha ocurrido un error al cargar configBusiness
			});
	}

	async getConfigBusiness() {
		const fetchConfigBusiness = () => {
			return fetch(Config.get('apiUrlBase') + '/commons/config-business', {
					method: 'GET',
					headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
					},
			});
		};

		try {
			const response = await fetchConfigBusiness();
			if (!response.ok) {
					throw new Error('Error al obtener la configuración de entorno');
			}
			const data = await response.json();
			if ((data.jsonDownloaded && data.jsonDownloaded.complete === 'true')
					|| (!data.json && data.json !== "error")) {
					localStorage.setItem("configBusiness", JSON.stringify(data));
			} else {
					throw new Error('Configuración de entorno incompleta');
			}
		} catch (error) {
			console.log('Error en configuración de entorno', error);
		}
	}

	async getConfig() {
		try {
				const response = await fetch('/config/config.json', {
						method: 'GET',
						headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json',
						},
				});
				const configData = await response.json();
				localStorage.setItem('config', JSON.stringify(configData));
		} catch (error) {
				console.log(error);
		}
	}

  	initForm() {
		/* this.setState({ loading: true });
		Promise.all([
			this.ajaxHandler.getJson("/public/safe-feedback-tipo-formularios/" + this.props.match.params.token)
		])
	  	.then((data) => {
			if(data[0]){
				let tipo_formulario = data[0];
				let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
				let valores_dinamicos = [];
				formDataCopy.tipo_formulario = tipo_formulario;
				if(tipo_formulario && !tipo_formulario.activo){
					swal2.fire(
						this.props.intl.formatMessage({ id: "SafeFeedbackFormularioRespuesta.error_al_cargar", defaultMessage: "Error al cargar el formulario" }),
						this.props.intl.formatMessage({ id: "SafeFeedbackFormularioRespuesta.formulario_inactivo", defaultMessage: "Formulario Inactivo" }),
						'error'
					);
					this.setState({ redirectTo: "/" });
				}
				if (tipo_formulario){
					if(tipo_formulario.administracion_de_atributos_json){
						let administracion_de_atributos_json = JSON.parse(tipo_formulario.administracion_de_atributos_json);
						if(administracion_de_atributos_json.includes("base")){
							fetch(Config.get('apiUrlBase') + '/public/bases/public-select-all', {
									method: 'GET',
									headers: {
											'Accept': 'application/json',
											'Content-Type': 'application/json'
									},
							})
							.then((response) => {
								response.json()
								.then((data) => {
									this.setState({ bases: data });
								})
								.catch((error) => {
									console.log(error);
								});
							});
							this.setState({
								mostrarBase: true,
							});
						}
					}
					valores_dinamicos = castValoresDinamicos(tipo_formulario.atributos_dinamicos, this.state.formData.valores_dinamicos);
				}
				this.setState({
					formData: formDataCopy,
					valores_dinamicos: valores_dinamicos,
				});
			}else{
				swal2.fire(
					this.props.intl.formatMessage({ id: "SafeFeedbackFormularioRespuesta.error_al_cargar", defaultMessage: "Error al cargar el formulario" }),
					this.props.intl.formatMessage({ id: "SafeFeedbackFormularioRespuesta.no_se_encontro", defaultMessage: "No se encontró el formulario" }),
					'error'
				);
				this.setState({ redirectTo: "/" });
			}
		})
		.catch(function (error) {
			console.log(error);
		})
		.finally(() => {
			this.setState({ loading: false });
		}); */
 	}
	componentWillMount() {
		this.loadConfigBusiness();
		this.ajaxHandler.subscribe(this);
		this.initForm();
	}
	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	handleTipoFormularioChange(tipo_formulario) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		let valores_dinamicos = [];
		if (tipo_formulario){
			formDataCopy.tipo_formulario = tipo_formulario;
			if(tipo_formulario.administracion_de_atributos_json){
				let administracion_de_atributos_json = JSON.parse(tipo_formulario.administracion_de_atributos_json);
				if(administracion_de_atributos_json.includes("base")){
					fetch(Config.get('apiUrlBase') + '/public/bases/public-select-all', {
							method: 'GET',
							headers: {
									'Accept': 'application/json',
									'Content-Type': 'application/json'
							},
					})
					.then((response) => {
						response.json()
						.then((data) => {
							this.setState({ bases: data });
						})
						.catch((error) => {
							console.log(error);
						});
					});
					this.setState({
						mostrarBase: true,
					});
				}
			}
			valores_dinamicos = castValoresDinamicos(tipo_formulario.atributos_dinamicos, this.state.formData.valores_dinamicos);
		}
		this.setState({
			formData: formDataCopy,
			valores_dinamicos: valores_dinamicos,
		});
	}

	handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy
		});
	}

  	handleChangeAtributoDinamico(index, key, value) {
		this.state.valores_dinamicos[index][key] = value;
		this.setState({
			valores_dinamicos: this.state.valores_dinamicos
		});
	}

	handleSelectChange(name, selectedOption) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = selectedOption;
		this.setState({
			formData: formDataCopy
		});
	}

	handleFileChange = (index, event) => {
		const files = event.target.files;
		let valores_dinamicos = [...this.state.valores_dinamicos];
		valores_dinamicos[index].archivos = files;
		valores_dinamicos[index].value = files ? 'ok' : null;
		this.setState({ valores_dinamicos });
	}

	// Maneja la firma para cada valor dinámico (puede haber varias firmas)
	handleFirmaChange = (index, imgBlob) => {
		let valores_dinamicos = [...this.state.valores_dinamicos];
		if (imgBlob) {
			const file = new File([imgBlob], 'firma.png', { type: 'image/png' });
			valores_dinamicos[index].archivos = [file]; // Cada índice puede tener su propia firma
			valores_dinamicos[index].firmaBlob = imgBlob;
			valores_dinamicos[index].value = imgBlob ? 'ok' : null;
		} else {
			valores_dinamicos[index].archivos = undefined;
			valores_dinamicos[index].firmaBlob = null;
			valores_dinamicos[index].value = null;
		}
		this.setState({ valores_dinamicos });
	}

	async handleSubmit(event) {
		this.setState({ loading: true });
		event.preventDefault();
		let component = this;
		let formData = new FormData();
		formData.append('safe_feedback_tipo_formulario_id', this.state.formData.tipo_formulario.id);
		formData.append('dominio', this.state.formData.dominio);
		formData.append('base_id', this.state.formData.base ? this.state.formData.base.value : '');
		let valoresDinamicosPayload = [];
		this.state.valores_dinamicos.forEach((atributo, idx) => {
			let atributoCopy = { ...atributo };
			if ((atributo.tipoValor === 5 || atributo.tipoValor === 6 || atributo.tipoValor === 7) && atributo.archivos && atributo.archivos.length > 0) {
				Array.from(atributo.archivos).forEach((file, fileIdx) => {
				let fieldKey = 'adjunto_' + idx + '_' + fileIdx;
				formData.append(fieldKey, file);
				atributoCopy['adjunto_file_key'] = fieldKey;
				});
			}
			valoresDinamicosPayload.push(atributoCopy);
		});
		formData.append('valores_dinamicos', JSON.stringify(valoresDinamicosPayload));
		formData.append('fecha_hora', moment(this.state.formData.fecha_hora).format('YYYY-MM-DD HH:mm:ss'));
		fetch(Config.get('apiUrlBase') + '/public/safe-feedback-formularios', {
			method: 'POST',
			body: formData
		})
		.then(response => {
			if (response.status !== 400) {
				swal2.fire(
					this.props.intl.formatMessage({ id: "SafeFeedbackFormularioRespuesta.reporte_enviado", defaultMessage: "Reporte enviado" }),
					'',
					'success'
				);
				this.setState({ redirectTo: "/" });
			} else {
				response.json().then(data => {
					swal2.fire(
						this.props.intl.formatMessage({ id: "SafeFeedbackFormularioRespuesta.error_al_enviar", defaultMessage: "Error al Enviar el Reporte" }),
						data.detalle ? data.detalle.join(', ') : '',
						'error'
					);
				});
			}
			window.scrollTo(0, 0);
		})
		.catch((error) => {
			component.ajaxHandler.handleError(error);
		})
		.finally(() => {
			this.setState({ loading: false });
		});
	}

	handleCancel(event) {
		this.exit();
	}

	exit() {
		this.setState({ redirectTo: "/" });
	}

	 getBackendTipoForms (searchTerm) {
		return this.ajaxHandler.getJson('/public/safe-feedback-tipo-formularios/simple-search?search=' + searchTerm).then(res => {
			return {
				options: res,
				complete: true
			}
		});
	}

	

	validarEvidenciaRequeridas(valores_dinamicos){
		if(valores_dinamicos){
			for (let index = 0; index < valores_dinamicos.length; index++) {
				let estadosInformativos = valores_dinamicos[index].estadosInformativos
				if(estadosInformativos && estadosInformativos.find(estado => estado.id == valores_dinamicos[index].estado)){
					if(valores_dinamicos[index].evidencia_observacion_obligatoria && !valores_dinamicos[index].observaciones)
					return false;
					if(valores_dinamicos[index].evidencia_documento_obligatoria){
						if(!valores_dinamicos[index].documento_id || (valores_dinamicos[index].documento_id && valores_dinamicos[index].documento_id.length === 0)){
							return false;
						}
					}
					if(valores_dinamicos[index].evidencia_imagen_obligatoria){
						if(!valores_dinamicos[index].adjunto_id || (valores_dinamicos[index].adjunto_id && valores_dinamicos[index].adjunto_id.length === 0)){
							return false;
						}
					}
				}
			}
		}
		return true;
	}

	render() {
		let state = this.state;
		this.formValidation.validate();
		let formData = this.state.formData;
		let validationState = this.formValidation.state;

		return (
			<React.Fragment>
				<div className="p-2">
					<div className="content-wrapper">
						<div className="content-body">
							{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
							{this.state.loading && <Loading />}
							<div className="row content-body">
								<div className="col-md-12">
									<div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
										{this.state.errors.map((e, i) => (
										<li key={i}>
											<FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings["errors.default"])} />
										</li>
										))}
									</div>
									<form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
										<div className="form-body">
										
												<div className="card pull-up">
													<div className="card-content">
														<div className="card-body">
															<h4 className="form-section">
																<i className="fa fa-file-text-o"></i>
																<FormattedMessage
																	id="SafeFeedbackFormularioRespuesta.form_to_complete.label_formulario_completar"
																	defaultMessage=" Formulario a Completar "
																/>
																<div className="float-right" style={{ fontSize: "14px" }}>
																*{" "}
																<FormattedMessage
																	id="SafeFeedbackFormularioRespuesta.form_to_complete.campos_requeridos"
																	defaultMessage="campos requeridos"
																/>
																</div>
															</h4>
															<div className="row">
																{/* Tipo Formulario */}
																<div className="col-md-6">
																	<div className="form-group row">
																		<label className="col-md-3 label-control col-form-label" htmlFor="identificador">
																		<FormattedMessage
																			id="SafeFeedbackFormularioRespuesta.general_data.label_tipo_de_reporte"
																			defaultMessage="Tipo de Reporte *:"
																		/>
																		</label>
																		<div className="col-md-8">
																		<Select.Async
																			name="tipo_formulario"
																			value={this.state.formData.tipo_formulario ? this.state.formData.tipo_formulario : null}
																			valueKey="id"
																			labelKey="nombre"
																			loadOptions={this.getBackendTipoForms}
																			onChange={this.handleTipoFormularioChange}
																		/>
																		</div>
																		<label className="col-md-1">
																		<i
																			className={
																			this.state.formData.tipo_formulario
																				? this.state.formData.tipo_formulario.icono + " fa-2x"
																				: ""
																			}
																		/>
																		</label>
																	</div>
																</div>
															</div>

															{this.state.formData.tipo_formulario && formData.tipo_formulario.descripcion && (
																<div className="row">
																	{/* Descripción */}
																	<div className="col-md-6">
																		<div className="form-group row">
																			<label className="col-md-3 label-control col-form-label" htmlFor="nombre">
																			<FormattedMessage
																				id="SafeFeedbackFormularioRespuesta.general_data.label_descripcion"
																				defaultMessage="Descripción:"
																			/>
																			</label>
																			<div className="col-md-9">
																			<p className="col-form-label">{formData.tipo_formulario.descripcion} </p>
																			</div>
																		</div>
																	</div>
																</div>
															)}
															{this.state.formData.tipo_formulario && (
															<>
																<div className="row">
																{/* Movil */}
																	<div className="col-md-6">
																		<div className="form-group row">
																			<label className="col-md-3 label-control col-form-label" htmlFor="movil">
																				<FormattedMessage
																				id="SafeFeedbackFormularioRespuesta.form_to_complete.label_movil"
																				defaultMessage="Móvil *:"
																				/>
																			</label>
																			<div className="col-md-9">
																				<input
																					type="text"
																					className="form-control"
																					id="dominio"
																					name="dominio"
																					placeholder={this.props.intl.formatMessage({ id: 'SafeFeedbackFormularioRespuesta.su_placa.placeholder', defaultMessage: 'Su placa' })}
																					value={this.state.formData.dominio}
																					onChange={this.handleInputFormChange}
																					maxLength={20}
																				/>
																			</div>
																		</div>
																	</div>
																	{this.state.mostrarBase &&
																		<div className="col-md-6">
																			<div className="form-group row">
																				<label className="col-md-3 label-control col-form-label" htmlFor="base">
																					<FormattedMessage id="SafeFeedbackFormularioRespuesta.base" defaultMessage="Base"/>:*
																				</label>
																				<div className="col-md-9">
																					<Select
																						id="base"
																						name="base"
																						placeholder={this.props.intl.formatMessage({ id: 'SafeFeedbackFormularioRespuesta.Seleccionar.placeholder', defaultMessage: 'Seleccionar' })}
																						options={this.state.bases}
																						valueKey='value'
																						labelKey='descripcion'
																						value={this.state.formData.base}
																						onChange={e => this.handleSelectChange('base', e)}
																					/>
																				</div>
																			</div>
																		</div>
																	}
																</div>
																<div className="row">
																	<div className="col-md-6">
																		<div className="form-group row">
																			<label className="col-md-3 label-control col-form-label" htmlFor="fecha">
																				<FormattedMessage id="ReporteFormulario.fecha" defaultMessage="Fecha"/>:*
																			</label>
																			<div className="col-md-9">
																			<DatePicker
																				id="fecha"
																				name="fecha"
																				className="form-control date-picker-placeholder"
																				dateFormat={LocaleFormat.getDateTimePickerFormat()}
																				placeholderText={this.props.intl.formatMessage({ id: 'ReporteFormulario.fecha.placeholder', defaultMessage: 'dd/mm/aaaa HH:mm' })}
																				onChange={(event) => this.handleDatePickerFormChange(event)}
																				onChangeRaw={(e) => e.preventDefault()}
																				selected={this.state.formData.fecha_hora === null ? null : moment(this.state.formData.fecha_hora)}
																				maxDate={moment()}
																				showTimeSelect
																				minTime={moment().startOf('day')}
																				maxTime={
																						this.state.formData.fecha_hora && moment(this.state.formData.fecha_hora).isSame(moment(), 'day')
																							? moment()
																							: moment('23:59', 'HH:mm')
																				}
																				timeIntervals = { 10 }
																			/>
																			</div>
																		</div>
																	</div>
																</div>
																<div className="row">
																{this.state.valores_dinamicos.map(
																	(atributoDinamico, index) => {
																		if (!atributoDinamico || !atributoDinamico.activo) return null;
																		if (atributoDinamico.tipoValor === 7) {
																			return (
																				<div className="col-md-12" key={index}>
																					<div className="form-group row">
																						<label className="col-md-3 label-control col-form-label">
																							{atributoDinamico.nombre} {atributoDinamico.required === true || atributoDinamico.required === 1 ? ' *' : ''}:
																						</label>
																						<div className="col-md-9">
																							<FirmaCanvas
																								value={atributoDinamico.firmaPreview}
																								onSave={imgBlob => this.handleFirmaChange(index, imgBlob)}
																								disabled={this.props.action === "VIEW"}
																							/>
																						</div>
																					</div>
																				</div>
																			);
																		}
																		if (atributoDinamico.tipoValor === 5 || atributoDinamico.tipoValor === 6) {
																			// Renderizar input file personalizado
																			return (
																				<div className="col-md-12" key={index}>
																					<div className="form-group row">
																						<label className="col-md-3 label-control col-form-label">
																							{atributoDinamico.nombre} {atributoDinamico.required === true || atributoDinamico.required === 1 ? ' *' : ''}:
																						</label>
																						<div className="col-md-9">
																							<input
																								type="file"
																								onChange={e => this.handleFileChange(index, e)}
																								accept={atributoDinamico.tipoValor === 5 ? 'image/*' : undefined}
																							/>
																						</div>
																					</div>
																				</div>
																			);
																		} else {
																			// Renderizar el resto normalmente
																			return (
																				<div className="col-md-12" key={index}>
																					<div className="form-group row">
																						<AtributoDinamicoInstancia
																							ocultarInput={this.props.action === "VIEW"}
																							handleChange={(name, value) =>
																								this.handleChangeAtributoDinamico(index, name, value)
																							}
																							atributo={atributoDinamico}
																						/>
																					</div>
																				</div>
																			);
																		}
																	}
																)}
																</div>
															</>)}
														</div>
													</div>
												</div>
											<div className="card pull-up">
												<div className="card-content">
													<div className="card-body">
														<div className="text-cd text-right">
														{this.props.action !== "VIEW" && (
																<button
																	type="submit"
																	className="btn btn-primary mr-1"
																	disabled={
																		!validationState.form.valid ||
																		atributosDinamicosRequeridosFaltantes(this.state.valores_dinamicos) ||
																		!this.validarEvidenciaRequeridas(this.state.valores_dinamicos) ||
																		(this.state.mostrarBase && !this.state.formData.base) ||
																		!this.state.formData.fecha_hora
																	}
																>
																	<i className="fa fa-check-circle"></i>
																	<FormattedMessage id="SafeFeedbackFormularioRespuesta.finish_button.guardar" defaultMessage=" Guardar" />
																</button>
														)}
														<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
															<i className="fa fa-times-circle"></i>{" "}
															{this.props.action === "VIEW"
															? this.props.intl.formatMessage({
																id: "SafeFeedbackFormularioRespuesta.finish_button.volver",
																defaultMessage: "Volver",
																})
															: this.props.intl.formatMessage({
																id: "SafeFeedbackFormularioRespuesta.finish_button.cancelar",
																defaultMessage: "Cancelar",
																})}
														</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default injectIntl(SafeFeedbackFormularioRespuesta);
